"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toNumber = void 0;
var lodash_1 = require("lodash");
var toNumber = function (val, fallback) {
  if (fallback === void 0) {
    fallback = 0;
  }
  var parsed = parseFloat(val);
  return (0, lodash_1.isNumber)(parsed) && !isNaN(parsed) ? parsed : fallback;
};
exports.toNumber = toNumber;